import { Modal, ModalBody } from "reactstrap";
import RequestCallBack from "..";
import LazyImage from "../../lazyImage";
import { unlockBodyScroll } from "../../../utility/utils";

const RequestCallBackPopUp = ({
    showModal,
    setShowModal,
    tag,
}: any) => {

    const planeIMG = `${process.env.PUBLIC_URL}/assets/icons/plane-with-map.svg`;
    const modalLeftIMG = `${process.env.PUBLIC_URL}/assets/images/explore-world.jpg`;

    const handleClose = () => {
        setShowModal(false);
    };

    const clearModalBodyGutter = () => {
        if (typeof document === "undefined") return;
        document.body.style.setProperty("padding-right", "0px", "important");
        document.documentElement.style.setProperty("padding-right", "0px", "important");
        document.querySelectorAll<HTMLElement>(".sticky-top, .fixed-top, .fixed-bottom, #header").forEach((el) => {
            el.style.setProperty("padding-right", "0px", "important");
        });
        // Prevent page from staying scrolled sideways behind the modal
        window.scrollTo({ left: 0 });
        document.documentElement.scrollLeft = 0;
        document.body.scrollLeft = 0;
    };

    return (
        <Modal
            isOpen={showModal}
            toggle={handleClose}
            centered
            size="xl"
            modalClassName="request-callback-modal"
            className="request-callback"
            contentClassName="request-callback-content"
            onOpened={clearModalBodyGutter}
            onClosed={() => {
                window.setTimeout(unlockBodyScroll, 0);
            }}
        >
            <ModalBody className="p-0">
                <button
                    type="button"
                    className="btn-closeCorner"
                    onClick={handleClose}>
                    <i className="bx bx-x"></i>
                </button>

                <div className="enquiry-modal position-relative">
                    <div
                        className="modal-left rounded-2"
                        style={{
                            backgroundImage: `linear-gradient(
                            to bottom,
                            rgba(146, 146, 146, 0.25),
                            rgba(26, 26, 26, 0.75)
                            ), url(${modalLeftIMG})`,
                        }}
                    >
                        <div className="overlay-content">
                            <span className="small-title">
                                Let's plan your
                            </span>

                            <h2>
                                Dream
                                <span>Getaway</span>
                            </h2>

                            <p>
                                Personalized travel ideas, best prices <br /> & hassle-free.
                            </p>

                            <div className="trust-box mx-auto">
                                <div className="icon">
                                    ⭐
                                </div>

                                <div>
                                    <h4>4.8/5 Rated</h4>
                                    <span>by 10,000+ Travelers</span>
                                </div>
                            </div>

                            <div className="trust-box mx-auto">
                                <div className="icon success">
                                    <i className="bx bx-shield-quarter"></i>
                                </div>

                                <div>
                                    <h4>Trusted Since 2014</h4>
                                    <span>Your journey, our promise</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-right rounded-2">
                        <LazyImage
                            loading="lazy"
                            src={planeIMG || `${process.env.PUBLIC_URL}/assets/images/no-image.jpg`}
                            className="planeIMG position-absolute"
                        />

                        <div className="content position-relative z-1">
                            <div className="text-center">
                                <h1>Plan Your Dream <br />Trip in Minutes</h1>
                                <p className="subtitle mb-4">
                                    Speak with a travel expert and get a personalized <br /> itinerary or quote.
                                </p>
                            </div>

                            <div className="features mb-3 justify-content-between text-start">
                                <div className="feature-item">
                                    <i className="bx bxs-phone-call"></i>
                                    <span>Expert <br />Consultation</span>
                                </div>

                                <div className="feature-item">
                                    <i className="bx bx-purchase-tag"></i>
                                    <span>Best Price <br />Guarantee</span>
                                </div>

                                <div className="feature-item">
                                    <i className="bx bx-shield"></i>
                                    <span>100% <br />Safe & Secure</span>
                                </div>
                            </div>

                            <RequestCallBack tag={tag} />

                            <div className="spam-note">
                                <i className="bx bx-lock-alt"></i>
                                No spam. Only expert travel advice.
                            </div>

                            <div className="limited-slot justify-content-center">
                                <i className="bx bxs-hot"></i>

                                <div>
                                    <strong>
                                        Limited slots available today!
                                    </strong>

                                    <span>
                                        Book your call before they're gone.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default RequestCallBackPopUp;
